import { useEffect, useState, VFC } from 'react'
import { truewhite } from 'src/styles/colors'
import styled, { keyframes } from 'styled-components'

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
`

export type ToastProps = {
  message: string
  type?: 'success' | 'error' | 'info'
  duration?: number
  onClose: () => void
  isVisible: boolean
}

const ToastComponent: VFC<ToastProps> = ({
  message,
  type = 'success',
  duration = 3000,
  onClose,
  isVisible,
}) => {
  const [isClosing, setIsClosing] = useState(false)

  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        setIsClosing(true)
        setTimeout(() => {
          onClose()
        }, 300) // アニメーション完了後に閉じる
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [isVisible, duration, onClose])

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      onClose()
    }, 300)
  }

  if (!isVisible) return null

  return (
    <ToastWrapper isClosing={isClosing}>
      <ToastContent type={type}>
        <ToastMessage>{message}</ToastMessage>
        <CloseButton onClick={handleClose} type="button">
          ✕
        </CloseButton>
      </ToastContent>
    </ToastWrapper>
  )
}

const ToastWrapper = styled.div<{ isClosing: boolean }>`
  animation: ${({ isClosing }) => (isClosing ? slideOut : slideIn)} 0.3s
    ease-in-out;
`

const ToastContent = styled.div<{ type: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 300px;
  max-width: 400px;
  padding: 20px 24px;
  background-color: #02b7b0;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`

const ToastMessage = styled.span`
  color: ${truewhite};
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0px;
  flex: 1;
  margin-right: 16px;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${truewhite};
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`

export const Toast = ToastComponent
